<i18n src='@/locale/ward-localization.json'></i18n>

<template>
    <v-select
        dense
        outlined
        clearable
        hide-details="auto"
        v-model="local_value"
        :item-text="displayName"
        item-value="id"
        :items="items"
        :label="$t('Ward')"
        @input="HandleInput"
    ></v-select>
</template>

<script>
import wardService from '@/service/ward-service';

export default {
    name: "wardService",
    props: {
        value: Number,
        departmentCode: Number
    },
    data() {
        return {
            local_value: null,
            items: []
        };
    },
    created() {
        this.GetData();
    },
    mounted() {
        this.local_value = this.value;
    },
    watch: {
        value(val) {
            this.local_value = val;
        },
        local_value(val) {
            if (val !== this.value) {
                this.HandleInput();
            }
        },
        departmentCode() {
            this.GetData();
        }
    },
    methods: {
        async GetData() {
            wardService
                .getWards(this.departmentCode)
                .then(response => this.items = response.data);
        },
        HandleInput() {
            this.$emit('input', this.local_value);
        },
        displayName(val) {
            return `${val.number} ${val.typeName || null} (${val.usedBedCount}/${val.bedCount})`
        }
    }
}
</script>

<style scoped>

</style>
